module.exports = __webpack_public_path__ + "img/nastavnik-vizual.bdae930b.png";